<div class="register-leave mat-body" *ngIf="transport">

  <div class="dialog-layout">

    <h2 class="dialog-h2">
      <sc-dictionary-label dictionaryKey="tmc-yard.ui.transport.register-leave.title"></sc-dictionary-label>
    </h2>


    <div class="top-info">
      <app-transport-info-panel [carrier]="transport.carrier" [identifier]="transport.identifier"
        [driver]="transport.name" [scope]="transport.transportScope"></app-transport-info-panel>
    </div>

    <div class="dialog-content">

      <div class="form-box">
        <h3>
          <sc-dictionary-label dictionaryKey="tmc-yard.ui.transport.register-leave.area-gate.title"></sc-dictionary-label>
        </h3>
        <mat-form-field  appearance="fill">
          <mat-select [(value)]="selectedAreaGate">
              <mat-option *ngFor="let gate of areaGates" [value]="gate">
                  {{ gate.name }}
              </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <form #weighForm="ngForm" class="weigh-input-form" *ngIf="isWeighingActive()">
        <div class="form-box">
          <h3>
            <sc-dictionary-label dictionaryKey="tmc-yard.ui.transport.register-leave.weighing.title"></sc-dictionary-label>
          </h3>
          <div class="flex-direction-row width-50 row-flex">
            <mat-form-field class="flex-grow-1" appearance="fill">
              <mat-label>
                <sc-dictionary-label dictionaryKey="tmc-yard.ui.transport.register-leave.weight"></sc-dictionary-label>
              </mat-label>
              <input name="value" matInput [(ngModel)]="transport.weight" #ctrlValue="ngModel" type="number" min="0"
                [readonly]="false"
                [required]="yardPropertiesService.getEntranceMinLength() > 0"
                appPositiveInteger>
              <mat-error *ngIf="showValuePositiveIntegerError(ctrlValue)">
                <sc-dictionary-label dictionaryKey="tmc.weigh-transport-dialog.error.value-no-integer"></sc-dictionary-label>
              </mat-error>
            </mat-form-field>
            <sc-button mat-icon-button class="weighingButton" (click)="readWeight()" [hidden]="isAutoWeighingVisible()"
              dictionaryKey="tmc.visit.overview.action.weighTransport"
              *ngIf="yardPropertiesService.isWeighingEnabled()">
              <sc-icon iconClass="fa-balance-scale"></sc-icon>
            </sc-button>
            <mat-form-field class="margin-left" appearance="fill">
              <mat-label>
                <sc-dictionary-label dictionaryKey="tmc-yard.common.type"></sc-dictionary-label>
              </mat-label>
              <mat-select name="type" [(ngModel)]="transport.weighingType" #ctrlType="ngModel"
                [required]="isWeighingTypeRequired()">
                <mat-option *ngFor="let o of typeOptions" value="{{o}}">
                  <sc-dictionary-label dictionaryKey="tmc-yard.ui.transport.details.dialog.weighingType.{{o}}"></sc-dictionary-label>
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </form>

      <div class="form-box">
        <sc-sub-title>
          <sc-dictionary-label dictionaryKey="tmc-yard.ui.transport.register-leave.checks.title"></sc-dictionary-label>
        </sc-sub-title>
        <div class="checks-list">
          <ul *ngIf="checksExist(transport)">
            <li class="check" *ngFor="let check of transport.checks">
              <div class="icon">
                <i class="fa-light"
                  [ngClass]="{'fa-check color-ok': isOk(check), 'fa-exclamation-triangle color-warn': isWarning(check), 'fa-exclamation-circle color-error': isFailed(check)}"></i>
              </div>
              <div class="message">
                <sc-dictionary-label [dictionaryKey]="check.nameDictionaryKey"></sc-dictionary-label>
                <ng-container *ngIf="descriptionExists(check)">
                  -
                  <sc-dictionary-label [dictionaryKey]="check.descriptionDictionaryKey"></sc-dictionary-label>
                </ng-container>
              </div>
            </li>
          </ul>
          <span *ngIf="!checksExist(transport)">
            <sc-dictionary-label dictionaryKey="tmc-yard.ui.transport.register-leave.checks.nochecks"></sc-dictionary-label>
          </span>
        </div>
      </div>

      <form *ngIf="allowExitDespiteOfRuleViolationEnabled" [formGroup]="allowExitDespiteOfRuleViolationFormGroup">
        <mat-checkbox formControlName="allowExitDespiteOfRuleViolation" name="allowExitDespiteOfRuleViolation">
          <sc-dictionary-label dictionaryKey="tmc-yard.ui.transport.register-leave.combined.allow-exit-despite-of-rule-violations"></sc-dictionary-label>
        </mat-checkbox>
      </form>

    </div>


    <div class="messages"></div>
    <sc-actionbar>
      <sc-content-spacer grow></sc-content-spacer>
      <button mat-stroked-button class="cancel-button" (click)="cancel()">
        <sc-dictionary-label dictionaryKey="tmc-yard.common.action.cancel"></sc-dictionary-label>
      </button>
      <sc-content-spacer></sc-content-spacer>
      <button mat-stroked-button class="" (click)="decline()" [disabled]="isDeclineDisabled()">
        <sc-dictionary-label dictionaryKey="tmc-yard.ui.transport.register-leave.action.decline"></sc-dictionary-label>
      </button>
      <sc-content-spacer></sc-content-spacer>
      <button mat-flat-button class="confirm-button" (click)="accept()" [disabled]="isAcceptDisabled">
        <sc-dictionary-label dictionaryKey="tmc-yard.ui.transport.register-leave.action.accept"></sc-dictionary-label>
      </button>
    </sc-actionbar>
  </div>
